import { styled } from '@linaria/react';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
const _exp = /*#__PURE__*/() => ContentWrapper;
const _exp2 = /*#__PURE__*/() => ({
  isMobile
}) => isMobile ? 'row' : 'column';
export const PageWrapper = /*#__PURE__*/styled(_exp())({
  name: "PageWrapper",
  class: "ppjvqgl",
  propsAsIs: true,
  vars: {
    "ppjvqgl-0": [_exp2()]
  }
});

require("./styled.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styled.tsx");